import { render, staticRenderFns } from "./Floors.vue?vue&type=template&id=f22cceb4&scoped=true"
import script from "./Floors.vue?vue&type=script&lang=js"
export * from "./Floors.vue?vue&type=script&lang=js"
import style0 from "./Floors.vue?vue&type=style&index=0&id=f22cceb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22cceb4",
  null
  
)

export default component.exports